import React from "react";
import { useTranslation } from "react-i18next";
import { toggleSheetReadOnly } from "../actions";
import { ActionMenu, ModalBuilder, Table } from "@redriver/cinnamon";
import { withRouter } from "react-router-dom";
import { withCurrentUser } from "features/../../../shared/components/auth";

import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { DropdownItem } from "semantic-ui-react";
import { ImpersonatedUserPermissionCheck } from "modules/ImpersonatedUserPermissions";

const ToggleSheetReadOnly = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  const { sheetId, sheetName, isReadOnly } = sheet;
  return (
    <ImpersonatedUserPermissionCheck
      target={Targets.Sheet}
      action={Actions.SetReadOnly}
    >
      <ModalBuilder
        withForm
        submitAction={toggleSheetReadOnly}
        submitParams={sheetId}
        onSubmitted={onSubmitted}
        renderTrigger={(trigger) => (
          <DropdownItem onClick={trigger}>
            {isReadOnly
              ? t("SheetActions.EditableSheet.TriggerText")
              : t("SheetActions.ReadOnlySheet.TriggerText")}
          </DropdownItem>
        )}
        renderModal={(modalProps) => (
          <TranslatedModal.Confirmation
            {...modalProps}
            header={
              isReadOnly
                ? t("SheetActions.EditableSheet.TriggerText")
                : t("SheetActions.ReadOnlySheet.TriggerText")
            }
            size="small"
          >
            {isReadOnly
              ? t("SheetActions.EditableSheet.ConfirmMessage", { sheetName })
              : t("SheetActions.ReadOnlySheet.ConfirmMessage", { sheetName })}
          </TranslatedModal.Confirmation>
        )}
      />
    </ImpersonatedUserPermissionCheck>
  );
};

export default withCurrentUser(withRouter(ToggleSheetReadOnly));
